import { render, staticRenderFns } from "./seoTakeDown.vue?vue&type=template&id=60990ace&scoped=true"
import script from "./seoTakeDown.vue?vue&type=script&lang=js"
export * from "./seoTakeDown.vue?vue&type=script&lang=js"
import style0 from "./seoTakeDown.vue?vue&type=style&index=0&id=60990ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60990ace",
  null
  
)

export default component.exports